(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vue-ionic", [], factory);
	else if(typeof exports === 'object')
		exports["vue-ionic"] = factory();
	else
		root["vue-ionic"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/lib/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(116);
	
	__webpack_require__(115);
	
	__webpack_require__(117);
	
	var _util = __webpack_require__(9);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _app = __webpack_require__(66);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _button = __webpack_require__(32);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icon = __webpack_require__(70);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _header = __webpack_require__(69);
	
	var _content = __webpack_require__(68);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _label = __webpack_require__(77);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _list = __webpack_require__(78);
	
	var _item = __webpack_require__(76);
	
	var _item2 = _interopRequireDefault(_item);
	
	var _itemGroup = __webpack_require__(72);
	
	var _itemGroup2 = _interopRequireDefault(_itemGroup);
	
	var _note = __webpack_require__(79);
	
	var _note2 = _interopRequireDefault(_note);
	
	var _thumbnail = __webpack_require__(80);
	
	var _thumbnail2 = _interopRequireDefault(_thumbnail);
	
	var _avatar = __webpack_require__(67);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _itemSliding = __webpack_require__(75);
	
	var _itemSliding2 = _interopRequireDefault(_itemSliding);
	
	var _indexTest = __webpack_require__(74);
	
	var _indexTest2 = _interopRequireDefault(_indexTest);
	
	var _itemOptions = __webpack_require__(73);
	
	var _itemOptions2 = _interopRequireDefault(_itemOptions);
	
	var _input = __webpack_require__(71);
	
	var _input2 = _interopRequireDefault(_input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VERSION = '0.0.1';
	var DEFAULT_CONFIG = {
	    theme: 'ios',
	    version: VERSION,
	    iconMode: ''
	};
	var install = function install(Vue) {
	    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (install.installed) return;
	    Vue.component(_button2.default.name, _button2.default);
	    Vue.component(_icon2.default.name, _icon2.default);
	    Vue.component(_app2.default.name, _app2.default);
	    Vue.component(_header.Header.name, _header.Header);
	    Vue.component(_header.Footer.name, _header.Footer);
	    Vue.component(_header.ToolBar.name, _header.ToolBar);
	    Vue.component(_header.Title.name, _header.Title);
	    Vue.component(_header.Buttons.name, _header.Buttons);
	    Vue.component(_content2.default.name, _content2.default);
	    Vue.component(_label2.default.name, _label2.default);
	    Vue.component(_list.List.name, _list.List);
	    Vue.component(_list.ListHeader.name, _list.ListHeader);
	    Vue.component(_item2.default.name, _item2.default);
	    Vue.component(_itemGroup2.default.name, _itemGroup2.default);
	    Vue.component(_note2.default.name, _note2.default);
	    Vue.component(_thumbnail2.default.name, _thumbnail2.default);
	    Vue.component(_avatar2.default.name, _avatar2.default);
	    Vue.component(_itemSliding2.default.name, _itemSliding2.default);
	    Vue.component(_indexTest2.default.name, _indexTest2.default);
	    Vue.component(_itemOptions2.default.name, _itemOptions2.default);
	    Vue.component(_input2.default.name, _input2.default);
	    Vue.prototype.$ionic = _util2.default.extend(DEFAULT_CONFIG, opts);
	};
	
	if (typeof window !== 'undefined' && window.Vue) {
	    install(window.Vue);
	};
	
	module.exports = {
	    version: VERSION,
	    install: install,
	    Button: _button2.default,
	    Header: _header.Header,
	    Footer: _header.Footer,
	    ToolBar: _header.ToolBar,
	    Title: _header.Title,
	    Buttons: _header.Buttons,
	    Content: _content2.default,
	    Label: _label2.default,
	    List: _list.List,
	    ListHeader: _list.ListHeader,
	    Item: _item2.default,
	    ItemGroup: _itemGroup2.default,
	    Note: _note2.default,
	    Thumbnail: _thumbnail2.default,
	    Avatar: _avatar2.default,
	    ItemSliding: _itemSliding2.default,
	    ItemOptions: _itemOptions2.default,
	    Input: _input2.default
	};

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {
	            theme: 'ios'
	        };
	    },
	    created: function created() {
	        if (this.theme != this.$ionic.theme) {
	            this.theme = this.$ionic.theme;
	        }
	    },
	
	    props: {
	        color: {
	            type: String,
	            default: 'default',
	            validator: function validator(value) {
	                return ['default', 'primary', 'light', 'secondary', 'danger', 'dark'].indexOf(value) > -1;
	            }
	        }
	    }
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(27)('wks')
	  , uid        = __webpack_require__(17)
	  , Symbol     = __webpack_require__(2).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 4 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(94)
	  , defined = __webpack_require__(21);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(12)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(8)
	  , createDesc = __webpack_require__(16);
	module.exports = __webpack_require__(6) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(10)
	  , IE8_DOM_DEFINE = __webpack_require__(36)
	  , toPrimitive    = __webpack_require__(29)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(6) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__(83);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    extend: function extend(obj) {
	        var args = Array.prototype.slice.call(arguments, 1);
	        for (var i = 0; i < args.length; i++) {
	            var source = args[i];
	            if (source) {
	                for (var prop in source) {
	                    obj[prop] = source[prop];
	                }
	            }
	        }
	        return obj;
	    },
	    nextUid: function nextUid() {
	        return 'ion' + nextId++;
	    },
	
	    debounce: function debounce(func, wait, immediate) {
	        var timeout, args, context, timestamp, result;
	        return function () {
	            context = this;
	            args = arguments;
	            timestamp = new Date();
	            var later = function later() {
	                var last = new Date() - timestamp;
	                if (last < wait) {
	                    timeout = setTimeout(later, wait - last);
	                } else {
	                    timeout = null;
	                    if (!immediate) result = func.apply(context, args);
	                }
	            };
	            var callNow = immediate && !timeout;
	            if (!timeout) {
	                timeout = setTimeout(later, wait);
	            }
	            if (callNow) result = func.apply(context, args);
	            return result;
	        };
	    },
	
	    throttle: function throttle(func, wait, options) {
	        var context, args, result;
	        var timeout = null;
	        var previous = 0;
	        options || (options = {});
	        var later = function later() {
	            previous = options.leading === false ? 0 : Date.now();
	            timeout = null;
	            result = func.apply(context, args);
	        };
	        return function () {
	            var now = Date.now();
	            if (!previous && options.leading === false) previous = now;
	            var remaining = wait - (now - previous);
	            context = this;
	            args = arguments;
	            if (remaining <= 0) {
	                clearTimeout(timeout);
	                timeout = null;
	                previous = now;
	                result = func.apply(context, args);
	            } else if (!timeout && options.trailing !== false) {
	                timeout = setTimeout(later, remaining);
	            }
	            return result;
	        };
	    },
	
	    inherit: function inherit(protoProps, staticProps) {
	        var parent = this;
	        var child;
	
	        if (protoProps && protoProps.hasOwnProperty('constructor')) {
	            child = protoProps.constructor;
	        } else {
	            child = function child() {
	                return parent.apply(this, arguments);
	            };
	        }
	
	        ionic.extend(child, parent, staticProps);
	
	        var Surrogate = function Surrogate() {
	            this.constructor = child;
	        };
	        Surrogate.prototype = parent.prototype;
	        child.prototype = new Surrogate();
	
	        if (protoProps) ionic.extend(child.prototype, protoProps);
	
	        child.__super__ = parent.prototype;
	
	        return child;
	    },
	    hasClass: function hasClass(el, cls) {
	        var elClass = el.className;
	
	        var arrElCls = elClass.split(/\s+/);
	        return arrElCls.indexOf(cls) != -1;
	    },
	    addClass: function addClass(el, cls) {
	        var elClass = el.className;
	
	        var blank = elClass != '' ? ' ' : '';
	        el.className = elClass + blank + cls;
	    },
	    removeClass: function removeClass(el, cls) {
	        var elClass = ' ' + el.className + ' ';
	
	        elClass = elClass.replace(/(\s+)/gi, ' ');
	
	        var removed = elClass.replace(' ' + cls + ' ', ' ');
	
	        removed = removed.replace(/(^\s+)|(\s+$)/g, '');
	
	        el.className = removed;
	    },
	    isUndefined: function isUndefined(value) {
	        return value === undefined;
	    },
	    isString: function isString(val) {
	        return typeof val === 'string';
	    },
	    isNumber: function isNumber(val) {
	        return typeof val === 'number';
	    },
	    isFunction: function isFunction(val) {
	        return typeof val === 'function';
	    },
	    isDefined: function isDefined(val) {
	        return typeof val !== 'undefined';
	    },
	    isPresent: function isPresent(val) {
	        return val !== undefined && val !== null;
	    },
	    isBlank: function isBlank(val) {
	        return val === undefined || val === null;
	    },
	    isObject: function isObject(val) {
	        return (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object';
	    },
	    isArray: function isArray(val) {
	        return Array.isArray(val);
	    }
	};

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 11 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 12 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 14 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(41)
	  , enumBugKeys = __webpack_require__(22);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 17 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 18 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var clickoutsideContext = '@@clickoutsideContext';
	
	exports.default = {
	    bind: function bind(el, binding, vnode) {
	        var documentHandler = function documentHandler(e) {
	            if (vnode.context && !el.contains(e.target)) {
	                vnode.context[el[clickoutsideContext].methodName]();
	            }
	        };
	        el[clickoutsideContext] = {
	            documentHandler: documentHandler,
	            methodName: binding.expression,
	            arg: binding.arg || 'click'
	        };
	        document.addEventListener(el[clickoutsideContext].arg, documentHandler);
	    },
	    update: function update(el, binding) {
	        el[clickoutsideContext].methodName = binding.expression;
	    },
	    unbind: function unbind(el) {
	        document.removeEventListener(el[clickoutsideContext].arg, el[clickoutsideContext].documentHandler);
	    },
	    install: function install(Vue) {
	        Vue.directive('clickoutside', {
	            bind: this.bind,
	            unbind: this.unbind
	        });
	    }
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(84), __esModule: true };

/***/ },
/* 20 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 21 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 22 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 23 */
/***/ function(module, exports) {

	module.exports = true;

/***/ },
/* 24 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(8).f
	  , has = __webpack_require__(4)
	  , TAG = __webpack_require__(3)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(27)('keys')
	  , uid    = __webpack_require__(17);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(2)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 28 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(13);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(2)
	  , core           = __webpack_require__(11)
	  , LIBRARY        = __webpack_require__(23)
	  , wksExt         = __webpack_require__(31)
	  , defineProperty = __webpack_require__(8).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(3);

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Button = __webpack_require__(131);
	
	Button.install = function (Vue) {
	  Vue.component(Button.name, Button);
	};
	module.exports = Button;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _theme = __webpack_require__(1);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    mixins: [_theme2.default],
	    data: function data() {
	        return {
	            componentName: 'ionItem'
	        };
	    },
	
	    methods: {
	        getText: function getText() {
	            var $labelEl = this.$refs.label.$el;
	            return $labelEl.textContent || '';
	        }
	    }
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13)
	  , document = __webpack_require__(2).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(2)
	  , core      = __webpack_require__(11)
	  , ctx       = __webpack_require__(91)
	  , hide      = __webpack_require__(7)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(6) && !__webpack_require__(12)(function(){
	  return Object.defineProperty(__webpack_require__(34)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(23)
	  , $export        = __webpack_require__(35)
	  , redefine       = __webpack_require__(42)
	  , hide           = __webpack_require__(7)
	  , has            = __webpack_require__(4)
	  , Iterators      = __webpack_require__(14)
	  , $iterCreate    = __webpack_require__(96)
	  , setToStringTag = __webpack_require__(25)
	  , getPrototypeOf = __webpack_require__(103)
	  , ITERATOR       = __webpack_require__(3)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(10)
	  , dPs         = __webpack_require__(100)
	  , enumBugKeys = __webpack_require__(22)
	  , IE_PROTO    = __webpack_require__(26)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(34)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(93).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(41)
	  , hiddenKeys = __webpack_require__(22).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ },
/* 40 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(4)
	  , toIObject    = __webpack_require__(5)
	  , arrayIndexOf = __webpack_require__(89)(false)
	  , IE_PROTO     = __webpack_require__(26)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(7);

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(104)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(37)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(110);
	var global        = __webpack_require__(2)
	  , hide          = __webpack_require__(7)
	  , Iterators     = __webpack_require__(14)
	  , TO_STRING_TAG = __webpack_require__(3)('toStringTag');
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype;
	  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}

/***/ },
/* 45 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'ion-app',
	    computed: {
	        cTheme: function cTheme() {
	            return '' + this.$ionic.theme;
	        }
	    }
	};

/***/ },
/* 46 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'ion-avatar',
	    props: {
	        src: {
	            type: String,
	            required: true
	        }
	    }
	};

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _theme = __webpack_require__(1);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ion-button',
	    mixins: [_theme2.default],
	    data: function data() {
	        return {
	            role: 'button',
	            isActive: false,
	
	            isParentItem: false
	        };
	    },
	
	    computed: {
	        aColor: function aColor() {
	            var theme = this.$ionic.theme;
	            switch (this.type) {
	                case 'outline':
	                case 'clear':
	                    return this.role + '-' + this.type + '-' + theme + '-' + this.color;
	                default:
	                    return this.role + '-' + theme + '-' + this.color;
	            }
	        },
	        aRound: function aRound() {
	            return this.round ? 'button-round button-round-' + this.theme : '';
	        },
	        aBlock: function aBlock() {
	            return this.block ? 'button-block button-block-' + this.theme : '';
	        },
	        aFull: function aFull() {
	            return this.full ? 'button-full button-full-' + this.theme : '';
	        },
	        aSize: function aSize() {
	            var size = this.size;
	            switch (this.size) {
	                case 'small':
	                case 'large':
	                    return this.role + '-' + size + ' ' + this.role + '-' + size + '-' + this.theme;
	                default:
	                    return '';
	            }
	        }
	    },
	    created: function created() {
	        var name = this.$parent.$data.componentName;
	        if (name === 'buttons') {
	            this.role = 'bar-button';
	        }
	
	        if (name === 'ionItem') {
	            this.isParentItem = true;
	        }
	    },
	
	    methods: {
	        handleTouchStart: function handleTouchStart(evt) {
	            this.isActive = true;
	            this.$emit('touchstart', evt);
	            window.addEventListener('touchend', this.handleTouchMove);
	            window.addEventListener('touchmove', this.handleTouchMove);
	        },
	        handleTouchMove: function handleTouchMove(e) {
	            this.isActive = false;
	        }
	    },
	    props: {
	        type: {
	            type: String,
	            default: 'default',
	            validator: function validator(value) {
	                return ['default', 'outline', 'clear'].indexOf(value) > -1;
	            }
	        },
	        round: Boolean,
	        block: Boolean,
	        full: Boolean,
	        size: {
	            type: String,
	            default: 'default',
	            validator: function validator(value) {
	                return ['default', 'small', 'large'].indexOf(value) > -1;
	            }
	        }
	    }
	};

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _theme = __webpack_require__(1);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ion-content',
	    mixins: [_theme2.default]
	};

/***/ },
/* 49 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'ion-buttons',
	    data: function data() {
	        return {
	            componentName: 'buttons'
	        };
	    },
	
	    computed: {
	        cTheme: function cTheme() {
	            return 'bar-buttons-' + this.$ionic.theme;
	        }
	    }
	};

/***/ },
/* 50 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'ion-footer',
	    computed: {
	        cTheme: function cTheme() {
	            return 'footer-' + this.$ionic.theme;
	        }
	    }
	};

/***/ },
/* 51 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'ion-header',
	    computed: {
	        cTheme: function cTheme() {
	            return 'header-' + this.$ionic.theme;
	        }
	    }
	};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _theme = __webpack_require__(1);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ion-title',
	    mixins: [_theme2.default]
	};

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _theme = __webpack_require__(1);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ion-toolbar',
	    mixins: [_theme2.default],
	    computed: {
	        aColor: function aColor() {
	            switch (this.color) {
	                case 'default':
	                    return '';
	                default:
	                    return 'toolbar-' + this.theme + '-' + this.color;
	            }
	        }
	    }
	};

/***/ },
/* 54 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var ICON_MODE = "ion";
	exports.default = {
	    name: 'ion-icon',
	    data: function data() {
	        return {
	            isParentItem: false
	        };
	    },
	
	    props: {
	        name: String,
	        color: String
	    },
	    created: function created() {
	        var name = this.$parent.$data.componentName;
	
	        if (name === 'ionItem') {
	            this.isParentItem = true;
	        }
	    },
	
	    computed: {
	        setName: function setName() {
	            var name = this.name;
	            if (!/^md-|^ios-|^logo-/.test(name)) {
	                var theme = this.$ionic.theme;
	                return 'ion-' + theme + ' ' + ICON_MODE + '-' + (theme === 'wp' ? 'ios' : theme) + '-' + name;
	            } else {
	                return name;
	            }
	        },
	        setColor: function setColor() {
	            return this.color ? 'icon-' + this.$ionic.theme + '-' + this.color : '';
	        }
	    }
	};

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _theme = __webpack_require__(1);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _button = __webpack_require__(32);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _clickoutside = __webpack_require__(18);
	
	var _clickoutside2 = _interopRequireDefault(_clickoutside);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ion-input',
	    mixins: [_theme2.default],
	    data: function data() {
	        return {
	            active: false,
	            currentValue: this.value
	        };
	    },
	    mounted: function mounted() {
	        var $parent = this.$parent;
	
	        if ($parent.componentName === 'ionItem') {
	            $parent.addClass('item-block item-input');
	        }
	        this.initAttr('floating');
	        this.initAttr('stacked');
	    },
	
	    props: {
	        type: {
	            type: String,
	            default: 'text'
	        },
	        placeholder: String,
	        readonly: Boolean,
	        disabled: Boolean,
	        disableClear: Boolean,
	        value: {},
	        attr: Object
	    },
	    methods: {
	        handleInput: function handleInput(evt) {
	            this.currentValue = evt.target.value;
	        },
	        handleClear: function handleClear() {
	            if (this.disabled || this.readonly) return;
	            this.currentValue = '';
	        },
	        doCloseActive: function doCloseActive() {
	            this.active = false;
	        },
	        initAttr: function initAttr(attr) {
	            var $parent = this.$parent;
	            var $el = this.$el;
	            if ($el.getAttribute(attr) != null) {
	                $parent.addClass('item-label-' + attr);
	
	                $parent.addLabelAttr(attr);
	            }
	        }
	    },
	    watch: {
	        value: function value(val) {
	            this.currentValue = val;
	        },
	        currentValue: function currentValue(val) {
	            var hasValue = val !== null && val !== undefined && val !== '';
	            this.$parent[hasValue ? 'addClass' : 'removeClass']('input-has-value');
	            this.$emit('input', val);
	        },
	        active: function active(val) {
	            var cls = 'input-has-focus';
	            this.$parent[val ? 'addClass' : 'removeClass'](cls);
	        }
	    },
	    components: {
	        ionButton: _button2.default
	    },
	    directives: {
	        Clickoutside: _clickoutside2.default
	    }
	};

/***/ },
/* 56 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'ion-item-group'
	};

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getIterator2 = __webpack_require__(19);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ion-item-options',
	    data: function data() {
	        return {
	            componentName: 'ionItemOptions'
	        };
	    },
	
	    methods: {
	        width: function width() {
	            var elRef = this.$slots.default || [];
	            var width = 0;
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = (0, _getIterator3.default)(elRef), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var el = _step.value;
	
	                    if (el.tag != undefined) {
	                        width += el.elm.getBoundingClientRect().width;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return width;
	        }
	    }
	};

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getIterator2 = __webpack_require__(19);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _util = __webpack_require__(9);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _clickoutside = __webpack_require__(18);
	
	var _clickoutside2 = _interopRequireDefault(_clickoutside);
	
	var _event = __webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ion-item-sliding-test',
	    directives: {
	        Clickoutside: _clickoutside2.default
	    },
	    data: function data() {
	        return {
	            start: {
	                x: 0,
	                y: 0
	            },
	            dragging: false
	        };
	    },
	    mounted: function mounted() {
	        var children = this.$children;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = (0, _getIterator3.default)(children), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var child = _step.value;
	
	                if (child.componentName === 'ionItem') {
	                    this.itemComponent = child;
	                }
	                if (child.componentName === 'ionItemOptions') {
	                    this.itemOptionsComponent = child;
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        if (!this.itemComponent) {
	            throw new Error('ion-item-sliding 组件下必须包含 ion-item');
	        }
	        this.itemWrap = this.itemComponent.$el;
	        this.optionsWraper = this.$el;
	        this.rightWrap = this.itemOptionsComponent.$el;
	        this.rightWidth = this.itemOptionsComponent.width();
	        this.rightWrap.style.webkitTransform = this.translate3d(this.rightWidth);
	        this.rightDefaultTransform = this.translate3d(this.rightWidth);
	    },
	
	    methods: {
	        translate3d: function translate3d(offset) {
	            return 'translate3d(' + offset + 'px, 0, 0)';
	        },
	        onSwipeMove: function onSwipeMove() {
	            var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	            console.log('onSwipeMove');
	            this.optionsWraper.style.webkitTransform = this.translate3d(offset);
	            if (offset === 0) {
	                this.dragging = false;
	                this.start.x = 0;
	                this.start.y = 0;
	                this.offsetLeft = 0;
	            }
	            this.swiping = true;
	        },
	        onStartDrag: function onStartDrag(evt) {
	            console.log('onStartDrag');
	            evt = evt.changedTouches ? evt.changedTouches[0] : evt;
	            this.dragging = true;
	            this.start.x = evt.pageX;
	            this.start.y = evt.pageY;
	        },
	        onDrag: function onDrag(evt) {
	            if (this.opened) {
	                !this.swiping && this.onSwipeMove(0);
	                this.opened = false;
	                return;
	            }
	            if (!this.dragging) return;
	            var swiping = void 0;
	            var e = evt.changedTouches ? evt.changedTouches[0] : evt;
	            var offsetTop = e.pageY - this.start.y;
	            var offsetLeft = this.offsetLeft = e.pageX - this.start.x;
	            var x = Math.abs(offsetLeft);
	
	            if (offsetLeft > 0 || x > this.rightWidth || !this.rightWidth) {
	                return;
	            }
	            var y = Math.abs(offsetTop);
	            swiping = !(x < 5 || x >= 5 && y >= x * 1.73);
	            if (!swiping) return;
	            evt.preventDefault();
	            this.onSwipeMove(offsetLeft);
	        },
	        endDrag: function endDrag(evt) {
	            console.log('endDrag');
	            if (!this.swiping) return;
	
	            this.swipeLeaveTransition(this.offsetLeft > 0 ? 1 : -1);
	        },
	        swipeLeaveTransition: function swipeLeaveTransition(direction) {
	            var _this = this;
	
	            setTimeout(function () {
	                _this.swipeLeave = true;
	                var oLeft = Math.abs(_this.offsetLeft);
	                console.log('oLeft', oLeft);
	
	                if (direction < 0 && oLeft > _this.rightWidth * 0.4) {
	                    _this.onSwipeMove(-_this.rightWidth);
	                    _this.swiping = false;
	                    _this.opened = true;
	                    return;
	                }
	                console.log('233 334');
	                _this.onSwipeMove(0);
	            }, 0);
	        }
	    }
	};

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getIterator2 = __webpack_require__(19);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _util = __webpack_require__(9);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _clickoutside = __webpack_require__(18);
	
	var _clickoutside2 = _interopRequireDefault(_clickoutside);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ion-item-sliding',
	    directives: {
	        Clickoutside: _clickoutside2.default
	    },
	    data: function data() {
	        return {
	            start: {
	                x: 0,
	                y: 0
	            },
	            dragging: false,
	            actived: false
	        };
	    },
	    mounted: function mounted() {
	        var children = this.$children;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = (0, _getIterator3.default)(children), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var child = _step.value;
	
	                if (child.componentName === 'ionItem') {
	                    this.itemComponent = child;
	                }
	                if (child.componentName === 'ionItemOptions') {
	                    this.itemOptionsComponent = child;
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        if (!this.itemComponent) {
	            throw new Error('ion-item-sliding 组件下必须包含 ion-item');
	        }
	        this.itemWrap = this.itemComponent.$el;
	        this.rightWrap = this.itemOptionsComponent.$el;
	        this.rightWidth = this.itemOptionsComponent.width();
	        this.rightDefaultTransform = this.translate3d(0);
	    },
	
	    methods: {
	        translate3d: function translate3d(offset) {
	            return 'translate3d(' + offset + 'px, 0, 0)';
	        },
	        onSwipeMove: function onSwipeMove() {
	            var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	            this.itemWrap.style.webkitTransform = this.translate3d(offset);
	            if (offset === 0) {
	                this.dragging = false;
	                this.actived = false;
	                this.start.x = 0;
	                this.start.y = 0;
	                this.offsetLeft = 0;
	            }
	            this.swiping = true;
	        },
	        onStartDrag: function onStartDrag(evt) {
	            evt = evt.changedTouches ? evt.changedTouches[0] : evt;
	            this.dragging = true;
	            this.start.x = evt.pageX;
	            this.start.y = evt.pageY;
	        },
	        onDrag: function onDrag(evt) {
	            if (this.opened) {
	                !this.swiping && this.onSwipeMove(0);
	                this.opened = false;
	                return;
	            }
	            if (!this.dragging) return;
	            var swiping = void 0;
	            var e = evt.changedTouches ? evt.changedTouches[0] : evt;
	            var offsetTop = e.pageY - this.start.y;
	            var offsetLeft = this.offsetLeft = e.pageX - this.start.x;
	            var x = Math.abs(offsetLeft);
	
	            if (offsetLeft > 0 || x > this.rightWidth || !this.rightWidth) {
	                return;
	            }
	            var y = Math.abs(offsetTop);
	            swiping = !(x < 5 || x >= 5 && y >= x * 1.73);
	            if (!swiping) return;
	            evt.preventDefault();
	            this.actived = true;
	            this.onSwipeMove(offsetLeft);
	        },
	        endDrag: function endDrag(evt) {
	            if (!this.swiping) return;
	
	            this.swipeLeaveTransition(this.offsetLeft > 0 ? 1 : -1);
	        },
	        swipeLeaveTransition: function swipeLeaveTransition(direction) {
	            var _this = this;
	
	            setTimeout(function () {
	                _this.swipeLeave = true;
	                var oLeft = Math.abs(_this.offsetLeft);
	
	                if (direction < 0 && oLeft > _this.rightWidth * 0.4) {
	                    _this.onSwipeMove(-_this.rightWidth);
	                    _this.swiping = false;
	                    _this.opened = true;
	                    return;
	                }
	                _this.onSwipeMove(0);
	            }, 0);
	        }
	    }
	};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _util = __webpack_require__(9);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _item = __webpack_require__(33);
	
	var _item2 = _interopRequireDefault(_item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ion-item',
	    mixins: [_item2.default],
	    data: function data() {
	        return {
	            itemCls: ''
	        };
	    },
	    mounted: function mounted() {
	        this.init();
	    },
	
	    props: {
	        type: {
	            type: String,
	            default: 'item'
	        }
	    },
	    methods: {
	        init: function init() {
	            var $el = this.$el;
	            var detailNone = 'detail-none';
	            var blockCls = 'item-block';
	            var type = this.type;
	            switch (type) {
	                case 'link':
	                    if ($el.hasAttribute(detailNone)) {
	                        $el.removeAttribute(detailNone);
	                    }
	                    break;
	                default:
	                    if (!$el.hasAttribute(detailNone)) {
	                        $el.setAttribute(detailNone, '');
	                    }
	                    break;
	            }
	
	            if (!_util2.default.hasClass($el, blockCls) && type != 'divider') {
	                _util2.default.addClass($el, blockCls);
	            }
	
	            if (type == 'divider' && !_util2.default.hasClass($el, 'ion-item-divider')) {
	                _util2.default.addClass($el, 'ion-item-divider');
	            }
	        },
	        addClass: function addClass(cls) {
	            var $el = this.$el;
	            if (!_util2.default.hasClass($el, cls)) {
	                _util2.default.addClass($el, cls);
	            }
	        },
	        removeClass: function removeClass(cls) {
	            var $el = this.$el;
	            if (_util2.default.hasClass($el, cls)) {
	                _util2.default.removeClass($el, cls);
	            }
	        },
	        addLabelAttr: function addLabelAttr(attr) {
	            var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	            var $labelEl = this.getText().length > 0 ? this.$refs.label.$el : this.$slots['ion-label'][0].elm;
	            if (!$labelEl.hasAttribute(attr)) {
	                $labelEl.setAttribute(attr, val);
	            }
	        }
	    }
	};

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _theme = __webpack_require__(1);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _util = __webpack_require__(9);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ion-label',
	    mixins: [_theme2.default],
	    data: function data() {
	        return {
	            viewLabel: true
	        };
	    },
	    beforeMount: function beforeMount() {
	        if (_util2.default.isUndefined(this.$slots.default)) {
	            this.viewLabel = false;
	        }
	    },
	
	    computed: {
	        aColor: function aColor() {
	            return 'label-' + this.theme + '-' + this.color;
	        }
	    }
	};

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _item = __webpack_require__(33);
	
	var _item2 = _interopRequireDefault(_item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ion-list-header',
	    mixins: [_item2.default]
	};

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _theme = __webpack_require__(1);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ion-list',
	    mixins: [_theme2.default]
	};

/***/ },
/* 64 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'ion-note'
	};

/***/ },
/* 65 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'ion-thumbnail',
	    props: {
	        src: {
	            type: String,
	            required: true
	        }
	    }
	};

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var App = __webpack_require__(129);
	
	App.install = function (Vue) {
	  Vue.component(App.name, App);
	};
	module.exports = App;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _avatar = __webpack_require__(130);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_avatar2.default.install = function () {
	  Vue.component(_avatar2.default.name, _avatar2.default);
	};
	
	exports.default = _avatar2.default;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _content = __webpack_require__(132);
	
	var _content2 = _interopRequireDefault(_content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_content2.default.install = function (Vue) {
	  Vue.component(_content2.default.name, _content2.default);
	};
	
	exports.default = _content2.default;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _header = __webpack_require__(135);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(134);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _toolbar = __webpack_require__(137);
	
	var _toolbar2 = _interopRequireDefault(_toolbar);
	
	var _title = __webpack_require__(136);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _buttons = __webpack_require__(133);
	
	var _buttons2 = _interopRequireDefault(_buttons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_header2.default.install = function (Vue) {
	    Vue.component(_header2.default.name, _header2.default);
	};
	
	_footer2.default.install = function (Vue) {
	    Vue.component(_footer2.default.name, _footer2.default);
	};
	
	_toolbar2.default.install = function (Vue) {
	    Vue.component(_toolbar2.default.name, _toolbar2.default);
	};
	
	_title2.default.install = function (Vue) {
	    Vue.component(_title2.default.name, _title2.default);
	};
	
	_buttons2.default.install = function (Vue) {
	    Vue.component(_buttons2.default.name, _buttons2.default);
	};
	
	module.exports = {
	    Header: _header2.default,
	    Footer: _footer2.default,
	    ToolBar: _toolbar2.default,
	    Title: _title2.default,
	    Buttons: _buttons2.default
	};

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Icon = __webpack_require__(138);
	
	Icon.install = function (Vue) {
	  Vue.component(Icon.name, Icon);
	};
	module.exports = Icon;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _input = __webpack_require__(139);
	
	var _input2 = _interopRequireDefault(_input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_input2.default.install = function () {
	    Vue.component(_input2.default.name, _input2.default);
	};
	
	exports.default = _input2.default;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _itemGroup = __webpack_require__(140);
	
	var _itemGroup2 = _interopRequireDefault(_itemGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_itemGroup2.default.install = function (Vue) {
	    Vue.component(_itemGroup2.default.name, _itemGroup2.default);
	};
	
	exports.default = _itemGroup2.default;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _itemOptions = __webpack_require__(141);
	
	var _itemOptions2 = _interopRequireDefault(_itemOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_itemOptions2.default.install = function (Vue) {
	    Vue.component(_itemOptions2.default.name, _itemOptions2.default);
	};
	
	exports.default = _itemOptions2.default;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _itemSlidingTest = __webpack_require__(142);
	
	var _itemSlidingTest2 = _interopRequireDefault(_itemSlidingTest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_itemSlidingTest2.default.install = function () {
	    Vue.component(_itemSlidingTest2.default.name, _itemSlidingTest2.default);
	};
	
	exports.default = _itemSlidingTest2.default;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _itemSliding = __webpack_require__(143);
	
	var _itemSliding2 = _interopRequireDefault(_itemSliding);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_itemSliding2.default.install = function (Vue) {
	    Vue.component(_itemSliding2.default.name, _itemSliding2.default);
	};
	
	exports.default = _itemSliding2.default;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _item = __webpack_require__(144);
	
	var _item2 = _interopRequireDefault(_item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_item2.default.install = function (Vue) {
	  Vue.component(_item2.default.name, _item2.default);
	};
	
	exports.default = _item2.default;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _label = __webpack_require__(145);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_label2.default.install = function (Vue) {
	  Vue.component(_label2.default.name, _label2.default);
	};
	
	exports.default = _label2.default;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ListHeader = exports.List = undefined;
	
	var _list = __webpack_require__(147);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _listHeader = __webpack_require__(146);
	
	var _listHeader2 = _interopRequireDefault(_listHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_list2.default.install = function (Vue) {
	    Vue.component(_list2.default.name, _list2.default);
	};
	
	_listHeader2.default.install = function (Vue) {
	    Vue.component(_listHeader2.default.name, _listHeader2.default);
	};
	
	exports.List = _list2.default;
	exports.ListHeader = _listHeader2.default;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _note = __webpack_require__(148);
	
	var _note2 = _interopRequireDefault(_note);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_note2.default.install = function () {
	  Vue.component(_note2.default.name, _note2.default);
	};
	
	exports.default = _note2.default;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _thumbnail = __webpack_require__(149);
	
	var _thumbnail2 = _interopRequireDefault(_thumbnail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_thumbnail2.default.install = function () {
	  Vue.component(_thumbnail2.default.name, _thumbnail2.default);
	};
	
	exports.default = _thumbnail2.default;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(85), __esModule: true };

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(86), __esModule: true };

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(82);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(81);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(44);
	__webpack_require__(43);
	module.exports = __webpack_require__(109);

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(112);
	__webpack_require__(111);
	__webpack_require__(113);
	__webpack_require__(114);
	module.exports = __webpack_require__(11).Symbol;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(43);
	__webpack_require__(44);
	module.exports = __webpack_require__(31).f('iterator');

/***/ },
/* 87 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 88 */
/***/ function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(5)
	  , toLength  = __webpack_require__(106)
	  , toIndex   = __webpack_require__(105);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(20)
	  , TAG = __webpack_require__(3)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(87);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(15)
	  , gOPS    = __webpack_require__(40)
	  , pIE     = __webpack_require__(24);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2).document && document.documentElement;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(20);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(20);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(38)
	  , descriptor     = __webpack_require__(16)
	  , setToStringTag = __webpack_require__(25)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(7)(IteratorPrototype, __webpack_require__(3)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 97 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(15)
	  , toIObject = __webpack_require__(5);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(17)('meta')
	  , isObject = __webpack_require__(13)
	  , has      = __webpack_require__(4)
	  , setDesc  = __webpack_require__(8).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(12)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(8)
	  , anObject = __webpack_require__(10)
	  , getKeys  = __webpack_require__(15);
	
	module.exports = __webpack_require__(6) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(24)
	  , createDesc     = __webpack_require__(16)
	  , toIObject      = __webpack_require__(5)
	  , toPrimitive    = __webpack_require__(29)
	  , has            = __webpack_require__(4)
	  , IE8_DOM_DEFINE = __webpack_require__(36)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(6) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(5)
	  , gOPN      = __webpack_require__(39).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(4)
	  , toObject    = __webpack_require__(107)
	  , IE_PROTO    = __webpack_require__(26)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(28)
	  , defined   = __webpack_require__(21);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(28)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(28)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(21);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(90)
	  , ITERATOR  = __webpack_require__(3)('iterator')
	  , Iterators = __webpack_require__(14);
	module.exports = __webpack_require__(11).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(10)
	  , get      = __webpack_require__(108);
	module.exports = __webpack_require__(11).getIterator = function(it){
	  var iterFn = get(it);
	  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(88)
	  , step             = __webpack_require__(97)
	  , Iterators        = __webpack_require__(14)
	  , toIObject        = __webpack_require__(5);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(37)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 111 */
/***/ function(module, exports) {



/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(2)
	  , has            = __webpack_require__(4)
	  , DESCRIPTORS    = __webpack_require__(6)
	  , $export        = __webpack_require__(35)
	  , redefine       = __webpack_require__(42)
	  , META           = __webpack_require__(99).KEY
	  , $fails         = __webpack_require__(12)
	  , shared         = __webpack_require__(27)
	  , setToStringTag = __webpack_require__(25)
	  , uid            = __webpack_require__(17)
	  , wks            = __webpack_require__(3)
	  , wksExt         = __webpack_require__(31)
	  , wksDefine      = __webpack_require__(30)
	  , keyOf          = __webpack_require__(98)
	  , enumKeys       = __webpack_require__(92)
	  , isArray        = __webpack_require__(95)
	  , anObject       = __webpack_require__(10)
	  , toIObject      = __webpack_require__(5)
	  , toPrimitive    = __webpack_require__(29)
	  , createDesc     = __webpack_require__(16)
	  , _create        = __webpack_require__(38)
	  , gOPNExt        = __webpack_require__(102)
	  , $GOPD          = __webpack_require__(101)
	  , $DP            = __webpack_require__(8)
	  , $keys          = __webpack_require__(15)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(39).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(24).f  = $propertyIsEnumerable;
	  __webpack_require__(40).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(23)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(7)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(30)('asyncIterator');

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(30)('observable');

/***/ },
/* 115 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 116 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 117 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 118 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 119 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 120 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 121 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 122 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 123 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 124 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 125 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 126 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 127 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 128 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(126)
	
	/* script */
	__vue_exports__ = __webpack_require__(45)
	
	/* template */
	var __vue_template__ = __webpack_require__(168)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(46)
	
	/* template */
	var __vue_template__ = __webpack_require__(154)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(127)
	
	/* script */
	__vue_exports__ = __webpack_require__(47)
	
	/* template */
	var __vue_template__ = __webpack_require__(169)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(122)
	
	/* script */
	__vue_exports__ = __webpack_require__(48)
	
	/* template */
	var __vue_template__ = __webpack_require__(164)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(49)
	
	/* template */
	var __vue_template__ = __webpack_require__(161)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(128)
	
	/* script */
	__vue_exports__ = __webpack_require__(50)
	
	/* template */
	var __vue_template__ = __webpack_require__(170)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(125)
	
	/* script */
	__vue_exports__ = __webpack_require__(51)
	
	/* template */
	var __vue_template__ = __webpack_require__(167)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(52)
	
	/* template */
	var __vue_template__ = __webpack_require__(160)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(119)
	
	/* script */
	__vue_exports__ = __webpack_require__(53)
	
	/* template */
	var __vue_template__ = __webpack_require__(157)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(124)
	
	/* script */
	__vue_exports__ = __webpack_require__(54)
	
	/* template */
	var __vue_template__ = __webpack_require__(166)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(121)
	
	/* script */
	__vue_exports__ = __webpack_require__(55)
	
	/* template */
	var __vue_template__ = __webpack_require__(163)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(56)
	
	/* template */
	var __vue_template__ = __webpack_require__(162)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(57)
	
	/* template */
	var __vue_template__ = __webpack_require__(153)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(58)
	
	/* template */
	var __vue_template__ = __webpack_require__(151)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(59)
	
	/* template */
	var __vue_template__ = __webpack_require__(150)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(123)
	
	/* script */
	__vue_exports__ = __webpack_require__(60)
	
	/* template */
	var __vue_template__ = __webpack_require__(165)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(120)
	
	/* script */
	__vue_exports__ = __webpack_require__(61)
	
	/* template */
	var __vue_template__ = __webpack_require__(159)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(62)
	
	/* template */
	var __vue_template__ = __webpack_require__(158)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(118)
	
	/* script */
	__vue_exports__ = __webpack_require__(63)
	
	/* template */
	var __vue_template__ = __webpack_require__(152)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(64)
	
	/* template */
	var __vue_template__ = __webpack_require__(155)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* script */
	__vue_exports__ = __webpack_require__(65)
	
	/* template */
	var __vue_template__ = __webpack_require__(156)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 150 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    directives: [{
	      name: "clickoutside",
	      rawName: "v-clickoutside:touchstart",
	      value: (onSwipeMove),
	      expression: "onSwipeMove",
	      arg: "touchstart"
	    }],
	    staticClass: "ion-item-sliding item-wrapper",
	    class: [actived ? 'active-slide active-options-right' : ''],
	    on: {
	      "click": function($event) {
	        onSwipeMove()
	      },
	      "touchstart": onStartDrag,
	      "touchmove": onDrag,
	      "touchend": endDrag
	    }
	  }, [_t("default")])
	}},staticRenderFns: []}

/***/ },
/* 151 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    directives: [{
	      name: "clickoutside",
	      rawName: "v-clickoutside:touchstart",
	      value: (onSwipeMove),
	      expression: "onSwipeMove",
	      arg: "touchstart"
	    }],
	    staticClass: "ion-item-sliding-test item-wrapper",
	    class: [dragging ? 'active-slide active-options-right' : ''],
	    on: {
	      "click": function($event) {
	        onSwipeMove()
	      },
	      "touchstart": onStartDrag,
	      "touchmove": onDrag,
	      "touchend": endDrag
	    }
	  }, [_t("default")])
	}},staticRenderFns: []}

/***/ },
/* 152 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "ion-list",
	    class: ['list-' + theme]
	  }, [_t("default")])
	}},staticRenderFns: []}

/***/ },
/* 153 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "ion-item-options"
	  }, [_t("default")])
	}},staticRenderFns: []}

/***/ },
/* 154 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('span', {
	    staticClass: "ion-avatar"
	  }, [_h('img', {
	    attrs: {
	      "src": src,
	      "alt": ""
	    }
	  })])
	}},staticRenderFns: []}

/***/ },
/* 155 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('span', {
	    staticClass: "ion-note"
	  }, [_t("default")])
	}},staticRenderFns: []}

/***/ },
/* 156 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "ion-thumbnail"
	  }, [_h('img', {
	    attrs: {
	      "src": src,
	      "alt": ""
	    }
	  })])
	}},staticRenderFns: []}

/***/ },
/* 157 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('nav', {
	    staticClass: "ion-navbar ion-toolbar toolbar ",
	    class: ['toolbar-' + theme, aColor]
	  }, [_h('div', {
	    staticClass: "toolbar-background ",
	    class: ['toolbar-background-' + theme]
	  }), " ", _t("buttons"), " ", _h('div', {
	    staticClass: "toolbar-content ",
	    class: ['toolbar-content-' + theme]
	  }, [_t("default")])])
	}},staticRenderFns: []}

/***/ },
/* 158 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "ion-list-header item ",
	    class: ['item-' + theme, 'list-header-' + theme]
	  }, [_h('div', {
	    staticClass: "item-inner"
	  }, [_h('div', {
	    staticClass: "input-wrapper"
	  }, [_t("ion-label"), " ", _h('ion-label', {
	    ref: "label"
	  }, [_t("default")]), " ", _t("item-content")]), " ", _t("item-right")]), " ", _m(0)])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "button-effect"
	  })
	}}]}

/***/ },
/* 159 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return (viewLabel) ? _h('label', {
	    staticClass: "ion-label",
	    class: ['label-' + theme, aColor]
	  }, [_t("default")]) : _e()
	}},staticRenderFns: []}

/***/ },
/* 160 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "ion-title ",
	    class: ['title-' + theme]
	  }, [_h('div', {
	    staticClass: "toolbar-title ",
	    class: ['toolbar-title-' + theme]
	  }, [_t("default")])])
	}},staticRenderFns: []}

/***/ },
/* 161 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('section', {
	    staticClass: "ion-buttons",
	    class: [cTheme]
	  }, [_t("default")])
	}},staticRenderFns: []}

/***/ },
/* 162 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('section', {
	    staticClass: "ion-item-group"
	  }, [_t("default")])
	}},staticRenderFns: []}

/***/ },
/* 163 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    class: [
	      type === 'textarea' ? 'ion-textarea input-ios' : 'ion-input',
	    ]
	  }, [(type !== 'textarea') ? [_h('input', {
	    directives: [{
	      name: "clickoutside",
	      rawName: "v-clickoutside",
	      value: (doCloseActive),
	      expression: "doCloseActive"
	    }],
	    ref: "input",
	    staticClass: "text-input ",
	    class: ['text-input-' + theme],
	    attrs: {
	      "placeholder": placeholder,
	      "number": type === 'number',
	      "type": type,
	      "disabled": disabled,
	      "readonly": readonly
	    },
	    domProps: {
	      "value": currentValue
	    },
	    on: {
	      "change": function($event) {
	        $emit('change', currentValue)
	      },
	      "focus": function($event) {
	        active = true
	      },
	      "blur": function($event) {
	        active = false
	      },
	      "input": handleInput
	    }
	  }), " ", (!disableClear) ? _h('ion-button', {
	    staticClass: "text-input-clear-icon",
	    attrs: {
	      "type": "clear",
	      "icon-only": ""
	    },
	    nativeOn: {
	      "click": function($event) {
	        handleClear($event)
	      }
	    }
	  }, [_m(0)]) : _e()] : _h('textarea', {
	    directives: [{
	      name: "clickoutside",
	      rawName: "v-clickoutside",
	      value: (doCloseActive),
	      expression: "doCloseActive"
	    }],
	    ref: "input",
	    staticClass: "text-input ",
	    class: ['text-input-' + theme],
	    attrs: {
	      "placeholder": placeholder,
	      "disabled": disabled,
	      "readonly": readonly
	    },
	    domProps: {
	      "value": currentValue
	    },
	    on: {
	      "change": function($event) {
	        $emit('change', currentValue)
	      },
	      "focus": function($event) {
	        active = true
	      },
	      "blur": function($event) {
	        active = false
	      },
	      "input": handleInput
	    }
	  }), " "])
	}},staticRenderFns: [function (){with(this) {
	  return _h('i', {
	    staticClass: "ion-icon ion-ios-close-outline",
	    attrs: {
	      "role": "img"
	    }
	  })
	}}]}

/***/ },
/* 164 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('section', {
	    staticClass: "ion-content ",
	    class: ['content-' + theme]
	  }, [_h('div', {
	    staticClass: "scroll-content"
	  }, [_t("default")]), " ", _t("ion-refresher")])
	}},staticRenderFns: []}

/***/ },
/* 165 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('a', {
	    staticClass: "item ",
	    class: ['item-' + theme, itemCls]
	  }, [_t("item-left"), " ", _h('div', {
	    staticClass: "item-inner"
	  }, [_h('div', {
	    staticClass: "input-wrapper"
	  }, [_t("ion-label"), " ", _h('ion-label', {
	    ref: "label"
	  }, [_t("default")]), " ", _t("item-content")]), " ", _t("item-right")]), " ", _m(0)])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "button-effect"
	  })
	}}]}

/***/ },
/* 166 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('i', {
	    staticClass: "ion-icon",
	    class: [setName, setColor, isParentItem ? 'item-icon' : ''],
	    attrs: {
	      "role": "img"
	    }
	  })
	}},staticRenderFns: []}

/***/ },
/* 167 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('header', {
	    staticClass: "ion-header",
	    class: [cTheme]
	  }, [_t("default")])
	}},staticRenderFns: []}

/***/ },
/* 168 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "ion-app",
	    class: [cTheme]
	  }, [_t("default")])
	}},staticRenderFns: []}

/***/ },
/* 169 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('button', {
	    staticClass: "disable-hover  ",
	    class: [
	      role,
	      theme ? role + '-' + theme : '',
	      type ? role + '-' + type : '',
	      theme ? role + '-' + type + '-' + theme : '',
	      aColor,
	      isActive ? 'activated' : '',
	      aRound,
	      aBlock,
	      aFull,
	      aSize,
	      isParentItem ? 'item-button' : ''
	    ],
	    on: {
	      "touchstart": handleTouchStart
	    }
	  }, [_h('span', {
	    staticClass: "button-inner"
	  }, [_t("default")]), " ", _m(0)])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "button-effect"
	  })
	}}]}

/***/ },
/* 170 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('footer', {
	    staticClass: "ion-footer",
	    class: [cTheme]
	  }, [_t("default")])
	}},staticRenderFns: []}

/***/ },
/* 171 */
/***/ function(module, exports) {

	var bindEvent = (function() {
	  if(document.addEventListener) {
	    return function(element, event, handler) {
	      if (element && event && handler) {
	        element.addEventListener(event, handler, false);
	      }
	    };
	  } else {
	    return function(element, event, handler) {
	      if (element && event && handler) {
	        element.attachEvent('on' + event, handler);
	      }
	    };
	  }
	})();
	
	var unbindEvent = (function() {
	  if(document.removeEventListener) {
	    return function(element, event, handler) {
	      if (element && event) {
	        element.removeEventListener(event, handler, false);
	      }
	    };
	  } else {
	    return function(element, event, handler) {
	      if (element && event) {
	        element.detachEvent('on' + event, handler);
	      }
	    };
	  }
	})();
	
	var bindOnce = function(el, event, fn) {
	  var listener = function() {
	    if (fn) {
	      fn.apply(this, arguments);
	    }
	    unbindEvent(el, event, listener);
	  };
	  bindEvent(el, event, listener);
	};
	
	module.exports = {
	  on: bindEvent,
	  off: unbindEvent,
	  once: bindOnce
	};

/***/ }
/******/ ])
});
;


// WEBPACK FOOTER //
// vue.ionic.min.js